import React, { useState, useEffect } from "react";
import { Info } from "lucide-react"; // Optional icon

const PaymentLimit = ({
  label = "Transaction Amount Per Month",
  min = 1,
  max = 10000,
  value,
  onChange,
}) => {
  const [limit, setLimit] = useState(value || max);

  // Sync internal state with prop value when it changes
  useEffect(() => {
    setLimit(value || max);
  }, [value, max]);

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    onChange && onChange(newLimit); // Notify parent
  };

  return (
    <div className="bg-light rounded p-3 mb-4">
      {/* Label with icon */}
      <div className="d-flex align-items-center mb-2">
        <span className="fw-bold me-2">{label}</span>
        <Info size={14} className="text-muted" />
      </div>

      {/* Value display */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="fw-semibold">Set Limit (INR)</span>
        <input
          type="text"
          value={limit}
          readOnly
          className="form-control text-end bg-dark text-white"
          style={{ width: "120px", fontWeight: "bold", borderRadius: "8px" }}
        />
      </div>

      {/* Slider */}
      <input
        type="range"
        className="form-range"
        min={min}
        max={max}
        value={limit}
        onChange={handleLimitChange}
        style={{ accentColor: "#004d40" }}
      />

      {/* Min-Max info */}
      <div className="d-flex justify-content-between text-muted small">
        <span>(Min) {min}</span>
        <span>(Max) {max}</span>
      </div>
    </div>
  );
};

export default PaymentLimit;
